(function(module) {
try {
  module = angular.module('betosyswebapp');
} catch (e) {
  module = angular.module('betosyswebapp', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('components/dashboard/driverDigitalTachoStatus/driverDigitalTachoStatusWidgetEdit.tpl.html',
    '<!DOCTYPE html><html lang="en"><head><meta charset="UTF-8"><title>Title</title></head><body></body></html>');
}]);
})();



// WEBPACK FOOTER //
// ./.tmp/components/dashboard/driverDigitalTachoStatus/driverDigitalTachoStatusWidgetEdit.tpl.js